<template>
  <page-header-wrapper>
    <div slot="extra">
      <go-back />
    </div>
    <a-card :body-style="{ padding: '24px 32px' }" :bordered="false">
      <a-form :form="form">
        <a-form-item>
          <a-input type="hidden" name="id" v-decorator="['id']" />
        </a-form-item>
        <a-form-item label="标题" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['name', { rules: [{ required: true, message: '请输入名称' }] }]"
            name="name"
            placeholder="请输入名称"
          />
        </a-form-item>
        <a-form-item label="链接" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="[
              'website',
              { rules: [{ required: true, message: '请输入正确的网址', type: 'url' }] }
            ]"
            name="website"
            placeholder="请输入链接"
          />
        </a-form-item>
        <a-form-item label="标签" :labelCol="labelCol" :wrapperCol="wrapperCol" help="注：英文逗号隔开">
          <a-textarea
            rows="4"
            name="keywords"
            placeholder="请输入标签"
            v-decorator="['keywords', { rules: [{ required: true, message: '请输入标签' }] }]"
          />
        </a-form-item>

        <a-form-item label="简介" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea
            rows="4"
            name="desc"
            placeholder="请输入简介"
            v-decorator="['desc', { rules: [{ required: true, message: '请输入简介' }] }]"
          />
        </a-form-item>
        <a-form-item label="头像" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <img-upload
            name="logo"
            v-decorator="['logo', { rules: [{ required: true, message: '请上传头像' }] }]"
          />
        </a-form-item>
        <a-form-item label="介绍" :labelCol="labelCol" :wrapperCol="{ lg: { span: 18 }, sm: { span: 18 } }">
          <u-editor
            name="description"
            v-decorator="['description', { rules: [{ required: true, message: '请输入介绍' }] }]"
          />
        </a-form-item>
        <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol" help="是否在前端展示，默认展示">
          <a-switch
            checked-children="展示"
            un-checked-children="隐藏"
            name="state"
            v-decorator="[
              'state',
              {
                valuePropName: 'checked',
                initialValue: true
              }
            ]"
          />
        </a-form-item>
        <a-form-item :wrapperCol="{ span: 24 }" style="text-align: center">
          <a-button :loading="formLoading" @click="handleSubmit(setFormData)" type="primary">提交</a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { form } from '@/mixins'
import { ImgUpload, UEditor, GoBack } from '@/components'
const fields = ['name', 'keywords', 'type', 'logo', 'desc', 'description', 'state', 'website', 'type']
const apiList = {
    getInfo: '/partners/',
    typeList: '/partners/type',
    create: '/partners/create/author'
}
export default {
    name: 'BookAuthorForm',
    mixins: [form],
    components: {
        ImgUpload,
        UEditor,
        GoBack
    },
    data () {
        return {
            typeLoading: false,
            typeList: [],
            apiList,
            fields
        }
    },
    mounted () {
        console.log(this)
        if (this.$route.params.id) {
            apiList.update = '/partners/' + this.$route.params.id + '/author'
            this.getFormData(this.$route.params.id, function (values) {
                values.state = values.state === 1 // 状态格式转换
            }) // 获取编辑信息
        }
    },
    methods: {
        /**
         * @Author: JDY
         * @Date: 2021-04-28 10:57:05
         * @LastEditTime: Do not edit
         * @LastEditors: JDY
         * @Description:整理表单数据
         * @param  {*}
         * @return {*}
         * @param {*} values
         */
        setFormData (values) {
            values.state = values.state ? 1 : 2
        }

    }
}
</script>
